// The /connect page: the sign-in step of the MCP authorization front. It runs on an issuer host
// (and on experimental as a pre-prod issuer), never boots the app session, and talks only to the
// front's /oauth/* endpoints. Request and response shapes are fixed by the backend's contract,
// mirrored in unit-tests/fixtures/oauth-contract.ts.

export const CONNECT_PATH = '/connect';

export const ConnectStep = {
  EMAIL: 'email',
  PASSWORD: 'password',
  NEW_PASSWORD: 'new-password',
  CONSENT: 'consent',
  ERROR: 'error'
} as const;
export type ConnectStepType = (typeof ConnectStep)[keyof typeof ConnectStep];

// Values of `error` on /connect. The page never shows the raw value; each maps to fixed copy.
export const ConnectError = {
  REDIRECT: 'redirect',
  SIGNIN_FAILED: 'signin_failed'
} as const;
export type ConnectErrorType = (typeof ConnectError)[keyof typeof ConnectError];

export const OAuthRouteMethod = {
  FEDERATED: 'federated',
  PASSWORD: 'password'
} as const;

export type OAuthRouteResult =
  | { method: typeof OAuthRouteMethod.FEDERATED; provider: string }
  | { method: typeof OAuthRouteMethod.PASSWORD };

export const OAuthSignInStatus = {
  SIGNED_IN: 'signed_in',
  NEW_PASSWORD_REQUIRED: 'new_password_required'
} as const;
export type OAuthSignInStatusType = (typeof OAuthSignInStatus)[keyof typeof OAuthSignInStatus];

export interface OAuthSignInResult {
  status: OAuthSignInStatusType;
}

export interface ConsentInfo {
  harness: string;
  redirectHost: string;
  email: string;
  remembered: boolean;
}

// The consent decision's answer: the harness redirect (with a code or access_denied) that the page
// navigates to.
export interface ConsentResult {
  redirect: string;
}

export const OAUTH_POST_HEADERS = {
  'X-Auth-Client': '1',
  'Content-Type': 'application/json'
} as const;
